import React from 'react';
import ComingSoon from '@/components/shared/ComingSoonSection';
import './SupportPage.scss';

const SupportPage = () => {
  return (
    <div className="SupportPage">
      <ComingSoon title="SupportPage" />
    </div>
  );
};

export default SupportPage;
